<template>
  <div class="notice-wrap" @click="showMore = !showMore">
    <van-notice-bar wrapable :scrollable="false" color="#333" background="#FFF8DE">
      <div class="notice-info" :class="showMore ? 'more' : ''">
        <div class="notice-con">
          <div v-if="type == 'share'" class="share-wrap">
            <div class="title">
              <van-icon name="volume-o" color="#FFA001" class="fl" style="margin-right: 5px;margin-top: 4px" />
              <p>PA：{{noticeData.paUserView && noticeData.paUserView.cname}}为您分享<span v-if="noticeData.projectName">【{{noticeData.projectName}}】</span></p>
            </div>
            <div class="share-info">
              <dl v-for="(item, index) in noticeData.positionShareEnterpriseVos">
                <dt>
                  {{index+1 + '、'}}{{item.enterpriseName}}
                  <p>{{item.projectBackdrop}}</p>
                </dt>
                <dd>
                  <p v-for="position in item.positions">{{position.positionTitle}}</p>
                </dd>
                <dd>{{item.positionDescription}}</dd>
              </dl>
            </div>
          </div>
          <div v-else>
            <div v-for="item in noticeData">
              <van-icon name="volume-o" color="#FFA001" />
              <p v-if="item.createTime">公告：<span class="time">{{item.createTime | date}}</span></p>
              <p class="comment" :title="item.comment">{{item.comment}}</p>
            </div>
          </div>
        </div>
      </div>
      <span class="red" v-if="showBtn">{{showMore ? '收起' : '展开'}}</span>
    </van-notice-bar>
  </div>
</template>

<script>

export default {
  props: {
    noticeData:{},
    type:''
  },
  data() {
    return {
      showMore: false,
      showBtn: false,
    };
  },
  mounted() {
    let tipsBox = document.getElementsByClassName('notice-con')[0];
    console.log(tipsBox.offsetHeight)
    if(tipsBox.offsetHeight > 48){
      this.showBtn = true;
    }

  },
};
</script>

<style lang="scss">
.notice-wrap{
  .notice-info{
    transition: all ease .4s;
    max-height: 48px;
    overflow: hidden;
    &.more{
      max-height: inherit;
    }
    .comment{
      white-space: pre-line;
      padding-left: 60px;
    }
  }
  .share-wrap{
    overflow: hidden;
    .share-info{
      margin-left: 18px;
      dt,dd{
        margin-bottom: 10px;
      }
    }
  }
}
</style>
